import { z } from 'zod';
import { ACTIVATION_CODE_PATTERN, ACTIVATION_CODE_ERROR_MESSAGE, } from '../constants/validation';
/**
 * Measurement system for height, weight, and other measurements
 */
export const MeasurementSystemSchema = z.enum(['metric', 'imperial']);
/**
 * Sex assigned at birth (for metabolic calculations)
 */
export const SexAssignedAtBirthSchema = z.enum([
    'male',
    'female',
    'prefer-not-to-say',
]);
/**
 * User Profile Schema
 * Validates user profile data structure per US-001 requirements
 */
export const UserProfileSchema = z.object({
    userId: z.string().uuid('User ID must be a valid UUID'),
    email: z.string().email('Invalid email address'),
    name: z.string().min(1, 'Name is required').max(200, 'Name too long'),
    createdAt: z.string().datetime('Invalid datetime'),
    updatedAt: z.string().datetime('Invalid datetime'),
    // Demographic fields
    preferredName: z.string().min(1).max(100).optional(),
    familyName: z.string().min(1).max(100).optional(),
    dateOfBirth: z.string().date().optional(),
    heightCm: z.number().min(50).max(300).optional(),
    sexAssignedAtBirth: SexAssignedAtBirthSchema.optional(),
    measurementSystem: MeasurementSystemSchema.optional(),
    // Optional fields
    phoneNumber: z.string().optional(),
    timezone: z.string().optional(),
    locale: z.string().optional(),
});
/**
 * Create User Request Schema
 * Validates request to create a new user via activation
 */
export const CreateUserRequestSchema = z.object({
    email: z.string().email('Invalid email address'),
    activationCode: z
        .string()
        .regex(ACTIVATION_CODE_PATTERN, ACTIVATION_CODE_ERROR_MESSAGE),
    name: z.string().min(1, 'Name is required').max(200, 'Name too long'),
    // Optional fields
    phoneNumber: z.string().optional(),
    timezone: z.string().default('UTC'),
    locale: z.string().default('en-US'),
});
/**
 * Update User Request Schema
 * Validates request to update user profile
 */
export const UpdateUserRequestSchema = z.object({
    name: z.string().min(1).max(200).optional(),
    email: z.string().email('Invalid email address').optional(),
    phoneNumber: z.string().optional(),
    timezone: z.string().optional(),
    locale: z.string().optional(),
    // Demographic fields
    preferredName: z.string().min(1).max(100).optional(),
    familyName: z.string().min(1).max(100).optional(),
    dateOfBirth: z.string().date().optional(),
    heightCm: z.number().min(50).max(300).optional(),
    sexAssignedAtBirth: SexAssignedAtBirthSchema.optional(),
    measurementSystem: MeasurementSystemSchema.optional(),
});
//# sourceMappingURL=user.js.map